module.exports = __webpack_public_path__ + "static/media/spinerlogo.97d4a06c.png";